import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CarouselComponent } from "./carousel/carousel.component";
import {BrandsComponent} from "./brands/brands.component";
import {ProductComponent} from "./product/product.component";
import {AddressesComponent} from "./addresses/addresses.component";
import {ManageAddressComponent} from "./addresses/manage-address/manage-address.component";
import {DialogModule} from "primeng/dialog";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {ConfirmDialogModule} from "primeng/confirmdialog";
import {TopFilterComponent} from "./top-filter/top-filter.component";
import {SidebarModule} from "primeng/sidebar";
import {GalleriaModule} from "primeng/galleria";
import {CarouselModule} from "primeng/carousel";

@NgModule({
  declarations: [
    CarouselComponent,
    BrandsComponent,
    ProductComponent,
    AddressesComponent,
    ManageAddressComponent,
    TopFilterComponent
  ],
  exports: [
    CarouselComponent,
    BrandsComponent,
    ProductComponent,
    AddressesComponent,
    ManageAddressComponent,
    TopFilterComponent
  ],
  imports: [
    CommonModule,
    CarouselModule,
    DialogModule,
    FormsModule,
    ReactiveFormsModule,
    ConfirmDialogModule,
    SidebarModule,
    GalleriaModule,
  ]
})
export class ComponentsModule { }
